import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { BiPieChart } from "react-icons/bi";
import { LuFilePenLine } from "react-icons/lu";
import { PiInvoice } from "react-icons/pi";
import { FiUsers } from "react-icons/fi";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import { IoBusinessOutline} from "react-icons/io5";
import api from "../services/api";
import { GrPower } from "react-icons/gr";
import { TbCashRegister } from "react-icons/tb";

const BusinessNav = ({ selectedBusiness }) => {
  const businessId = selectedBusiness?.id;
  const navigate = useNavigate();
  // helper to render a nav item
  const Item = ({ to, end, icon: Icon, children }) => (
    <li>
      <NavLink
        to={to}
        end={end}
        className={({ isActive }) =>
          `nav-link ${isActive ? "active" : ""}`
        }
      >
        <Icon />
        <span>{children}</span>
      </NavLink>
    </li>
  );

  const handleLogout = async () => {
        try {
            // Invalidate the refresh token and clear the cookie on the server
            await api.post("/logout");
    
            // Remove any stored access tokens (if you're storing it anywhere)
            localStorage.removeItem("accessToken");
            sessionStorage.removeItem("accessToken");
    
            // Remove Authorization header from future requests
            delete api.defaults.headers.common["Authorization"];
    
            // Redirect to public page
            navigate("/home");
    
            // Force full reload to clear any React state and cached user data
            window.location.reload();
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

  return (
    <div className="nav-panel">
      {/* <div className="main-logo">
                <img
  src="/logo670.png"
  alt="Payweek Logo"
  className="dashboard-logo logo--light"
/>


 <img
  src="/logo512.png"
  alt="Payweek Logo"
  className="dashboard-logo logo--dark"
/> 

                   </div> */}

      <ul>
        {businessId && (
          <div>
          
            <Item to={`/dashboard/business/${businessId}`} end icon={IoBusinessOutline}>
              Business Page
            </Item>
            <Item to={`/dashboard/business/employees`} icon={FiUsers}>
              Employees
            </Item>
            <Item to={`/dashboard/business/${businessId}/viewpayroll`} icon={LiaMoneyCheckAltSolid}>
              Payroll
            </Item>
            <Item to={`/dashboard/business/${businessId}/check-write`} icon={LuFilePenLine}>
              Check Writer
            </Item>
            <Item to={`/dashboard/business/${businessId}/invoicing`} icon={PiInvoice}>
              Invoice
            </Item>
            <Item to={`/dashboard/business/${businessId}/accounting`} icon={BiPieChart}>
              Accounting
            </Item>
            <Item to={`/dashboard/business/${businessId}/cash-in`} icon={TbCashRegister}>
              Cash In
            </Item>
            {/* <Item to={`/dashboard/business/${businessId}/admin-payroll`} icon={TbCashRegister}>
              Cash In
            </Item>
            <Item to={`/dashboard/business/${businessId}/UI-wages`} icon={TbCashRegister}>
              Cash In
            </Item>
            <Item to={`/dashboard/business/${businessId}/edit-previous-payroll`} icon={TbCashRegister}>
              Cash In
            </Item> */}
          </div>
        )}

        
      </ul>
      <div className="logout-icon">
       <button onClick={handleLogout}>
       <GrPower/> 
       
                   Logout
                </button>
</div>

    </div>
  );
};

export default BusinessNav;



// import React from "react";
// import { Link } from "react-router-dom";
// import { BiPieChart } from "react-icons/bi";
// import { LuFilePenLine } from "react-icons/lu";
// import { PiInvoice } from "react-icons/pi";
// import { FiUsers } from "react-icons/fi";
// //import { IoIosBusiness } from "react-icons/io";
// import { LiaMoneyCheckAltSolid } from "react-icons/lia";
// import { IoBusinessOutline } from "react-icons/io5";
// import { IoSettingsOutline } from "react-icons/io5";

// const BusinessNav = ({ selectedBusiness }) => {
//     const businessId = selectedBusiness?.id;

//     return (
//         <div className="nav-panel">
//         <div>
//             <img 
//                 src="/logo512.png" 
//                 alt="Payweek Logo"  
//                 className="dashboard-logo"
//                 />


//             </div>
//             <ul>
//                 {businessId && (
//                     <>  
//                         <li style={{fontSize:"14px", marginTop:"30px"}}><Link to={`/dashboard/business/${businessId}`}><IoBusinessOutline/> Business Page</Link></li>
//                         <li style={{fontSize:"14px"}}><Link to={`/dashboard/business/${businessId}/employees`}><FiUsers/> Employees</Link></li>
//                         <li style={{fontSize:"14px"}}><Link to={`/dashboard/business/${businessId}/viewpayroll`}><LiaMoneyCheckAltSolid/> Payroll</Link></li>
//                         <li style={{fontSize:"14px"}}><Link to={`/dashboard/business/${businessId}/check-write`}><LuFilePenLine/> Check Writer</Link></li>
//                         <li style={{fontSize:"14px"}}><Link to={`/dashboard/business/${businessId}/invoiceref`}><PiInvoice/> Invoice</Link></li>
//                         <li style={{fontSize:"14px"}}><Link to={`/dashboard/business/${businessId}/accounting`}><BiPieChart/> Accounting</Link></li>
//                         <li style={{fontSize:"14px"}}><Link to={`/dashboard/business/${businessId}/cash-in`}><BiPieChart/>Cash In</Link></li>
//                     </>
//                 )}
//                 <>
//                     {/* Settings Link */}
//                     <li style={{fontSize:"13px"}}>
//                         <Link to="/dashboard/business/user/profile">
//                             <IoSettingsOutline/> Settings
//                             <span className="settings-text"></span>
//                         </Link>
//                     </li>
//                 </>
//             </ul>
//         </div>
//     );
// };

// export default BusinessNav;




// import React from "react";
// import { Link } from "react-router-dom";
// import { BsCashStack } from "react-icons/bs";
// import { BsCalculator } from "react-icons/bs";

// const BusinessNav = ({ selectedBusiness }) => {
//     const businessId = selectedBusiness?.id;

//     return (
//         <div className="nav-panel">
//             <ul>
//                 {businessId && (
                    
//                     <>  
//                         <li><Link to={`/dashboard/business/${businessId}`}>Business Page</Link></li>
//                         {/* <li><Link to={`/dashboard/business/${businessId}/add-employee`}>Add Employee</Link></li> */}
//                         <li><Link to={`/dashboard/business/${businessId}/employees`}>Employees</Link></li>
//                         {/* <li><Link to={`/dashboard/business/${businessId}/start-payroll`}>Start Payroll</Link></li> */}
//                         <li><Link to={`/dashboard/business/${businessId}/viewpayroll`}><BsCashStack style={{ marginRight: "8px", color: "#28e326" }} />Payroll</Link></li>
//                         <li><Link to={`/dashboard/business/${businessId}/transactions`}>Billing</Link></li>
//                         <li><Link to={`/dashboard/business/${businessId}/accounting`}><BsCalculator style={{ marginRight: "8px", color: "#28e326" }} />Accounting</Link></li>
//                     </>
//                 )}
//             </ul>
//         </div>
//     );
// };

// export default BusinessNav;


// import React from "react";
// import { Link } from "react-router-dom";

// const BusinessNav = ({ selectedBusiness }) => {
//     const businessId = selectedBusiness?.id;

//     return (
//         <div className="nav-panel">
//             <h3>Navigation</h3>
//             <ul>
//                 {businessId && (
//                     <>  
//                         <li><Link to={/dashboard/business/${businessId}}>Business Page</Link></li>
//                         <li><Link to={/dashboard/business/${businessId}/add-employee}>Add Employee</Link></li>
//                         <li><Link to={/dashboard/business/${businessId}/employees}>Edit Employees</Link></li>
//                         <li><Link to={/dashboard/business/${businessId}/start-payroll}>Start Payroll</Link></li>
//                         <li><Link to={/dashboard/business/${businessId}/view-payrolls}>View Payrolls</Link></li>
//                         <li><Link to={/dashboard/business/${businessId}/payroll-reports}>Payroll Reports</Link></li>
//                         <li><Link to={/dashboard/business/${businessId}/transactions}>Transactions</Link></li>
//                         <li><Link to={/dashboard/business/${businessId}/accounting-reports}>Accounting Reports</Link></li>
//                     </>
//                 )}
//             </ul>
//         </div>
//     );
// };

// export default BusinessNav;



// import React from "react";
// import { Link } from "react-router-dom";

// const BusinessNav = ({ selectedBusiness }) => {
//     const businessId = selectedBusiness?.id;

//     return (
//         <div className="nav-panel">
//             <h3>Navigation</h3>
//             <ul>
//                 <li><Link to="/dashboard/add-business">Add Business</Link></li>
//                 {businessId && (
//                     <>
//                         <li><Link to={`/dashboard/business/${businessId}/add-employee`}>Add Employee</Link></li>
//                         <li><Link to={`/dashboard/business/${businessId}/employees`}>Edit Employees</Link></li>
//                         <li><Link to={`/dashboard/business/${businessId}/start-payroll`}>Start Payroll</Link></li>
//                         <li><Link to={`/dashboard/business/${businessId}/view-payrolls`}>View Payrolls</Link></li>
//                         <li><Link to={`/dashboard/business/${businessId}/payroll-reports`}>Payroll Reports</Link></li>
//                         <li><Link to={`/dashboard/business/${businessId}/transactions`}>Transactions</Link></li>
//                         <li><Link to={`/dashboard/business/${businessId}/accounting-reports`}>Accounting Reports</Link></li>
//                     </>
//                 )}
//             </ul>
//         </div>
//     );
// };

// export default BusinessNav;





// import React from "react";
// import { Link } from "react-router-dom";

// const BusinessNav = ({ selectedBusiness }) => {
//     const businessId = selectedBusiness?.id;

//     return (
//         <div className="nav-panel">
//             <h3>Navigation</h3>
//             <ul>
//                 <li><Link to="/add-business">Add Business</Link></li>
//                 {businessId && (
//                     <>
//                         <li><Link to={`/business/${businessId}/add-employee`}>Add Employee</Link></li>
//                         <li><Link to={`/business/${businessId}/employees`}>Edit Employees</Link></li>
//                         <li><Link to={`/business/${businessId}/start-payroll`}>Start Payroll</Link></li>
//                         <li><Link to={`/business/${businessId}/view-payrolls`}>View Payrolls</Link></li>
//                         <li><Link to={`/business/${businessId}/payroll-reports`}>Payroll Reports</Link></li>
//                         <li><Link to={`/business/${businessId}/transactions`}>Transactions</Link></li>
//                         <li><Link to={`/business/${businessId}/accounting-reports`}>Accounting Reports</Link></li>
//                     </>
//                 )}
//             </ul>
//         </div>
//     );
// };

// export default BusinessNav;
